<template>
  <div>
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <div class="flex_between_wrap">
        <el-form-item
          :prop="start.model"
          style="width:300px;"
          v-for="(start, sindex) in firstItem"
          :key="sindex"
          :label="start.label"
          :rules="start.rules ? formRules.requiredChange : formRules.not"
        >
          <!-- 管理员 -->
          <!-- <x-select
            :placeholder="'请选择' + start.label"
            ref="assetAdmin"
            style="flex:1;"
            v-if="start.model == 'usePerson'"
            @change="assetAdminChange"
            label="staffName"
            model="id"
            v-model="formParams[start.model]"
            url="/pc/admin/page"
            :params="{
              type: 'all',
            }"
          ></x-select> -->
          <el-input
            style="flex:1;"
            v-if="start.model == 'usePersonName'"
            @focus="usePersonFocus"
            v-model="formParams[start.model]"
            :placeholder="'请选择' + start.label"
          ></el-input>
          <el-date-picker
            style="width:100%"
            v-else-if="start.model == 'startTime'"
            v-model="formParams[start.model]"
            align="right"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="`选择` + '维修日期'"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [
                {
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  },
                },
                {
                  text: '昨天',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                  },
                },
                {
                  text: '一周前',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                  },
                },
              ],
            }"
          >
          </el-date-picker>
          <el-input-number
            :placeholder="'请输入' + start.label"
            v-else-if="start.model == 'price'"
            style="width:100%"
            v-model="formParams[start.model]"
            :min="0"
            :precision="2"
            :controls="false"
          ></el-input-number>
          <el-input
            v-else
            autosize
            :placeholder="'请输入' + start.label"
            :type="start.type ? start.type : 'text'"
            v-model="formParams[start.model]"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>

    <!-- <el-divider content-position="left"
      ><span class="dividerTitle">待变更资产</span></el-divider
    > -->

    <!-- <div class="flex_between_nowrap">
      <el-button type="main">移除资产</el-button>
      <div class="flex_end">
        <el-input
              size="small"
          v-model="tableParams['assetCode']"
          style="margin-right:20px"
          placeholder="请输入条码或扫描条码"
        ></el-input>
        <el-button type="main">添加资产</el-button>
      </div>
    </div> -->

    <div class="dialog_bottom" style="margin-top:20px">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    callBack: Function,
    changeData: Array,
    ids: Array,
  },
  data() {
    return {
      formParams: { ids: this.ids },

      firstItem: [
        {
          label: "报修人",
          model: "usePersonName",
          rules: true,
        },
        {
          label: "维修原因",
          model: "repairRemark",
          rules: true,
          type: "textarea",
        },

        {
          label: "维修费用",
          model: "price",
        },

        {
          label: "维修日期",
          model: "startTime",
          rules: true,
        },

        {
          label: "维修备注",
          model: "remark",
          type: "textarea",
        },
      ],
    };
  },
  watch: {},
  mounted() {},
  methods: {
        usePersonCallBack(data) {
      if (data.id) {
          this.$set(this.formParams,'usePersonName',data.staffName)
        this.$set(this.formParams,'usePerson',data.id)
      }
        
    },
    usePersonFocus() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          callBack: this.usePersonCallBack,
        },
      });
    },
    init() {
      this.$set(this.formParams, "startTime", this.$getCurrentDate());
    },
    assetAdminChange(data) {
      if (data) {
        let node = this.$refs.assetAdmin[0].nodeData;
        for (let i = 0; i < node.length; i++) {
          if (node[i].id == data) {
            this.$set(this.formParams, "usePersonName", node[i].staffName);
            break;
          }
        }
      } else {
        this.$set(this.formParams, "usePersonName", "");
      }
    },

    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        let submit = JSON.parse(JSON.stringify(this.formParams));
        this.$requestAxiosForm(
          {
            url: "/pc/operate/repair",
            data: submit,
          },
          (data) => {
            this.$success();
            this.closeDialog();
            this.callBack();
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.dividerTitle {
  font-size: 18px;
  letter-spacing: 0px;
  color: #436bff;
  font-weight: bold;
}
</style>
